import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meu-pdv',
  templateUrl: './meu-pdv.component.html',
  styleUrls: ['./meu-pdv.component.scss']
})
export class MeuPdvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
